import { AuthResponseDto, LoginDto } from "@reactive-resume/dto";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { useNavigate } from "react-router-dom";

import { axios } from "@/client/libs/axios";
import { queryClient } from "@/client/libs/query-client";
import { useAuthStore } from "@/client/stores/auth";
import { fetchResumes } from "@/client/services/resume/resumes";
import { RESUMES_KEY } from "@/client/constants/query-keys";

export const login = async (data: LoginDto) => {
  const response = await axios.post<AuthResponseDto, AxiosResponse<AuthResponseDto>, LoginDto>(
    "/auth/login",
    data,
  );

  return response.data;
};

export const useLogin = () => {
  const navigate = useNavigate();
  const setUser = useAuthStore((state) => state.setUser);

  const {
    error,
    isPending: loading,
    mutateAsync: loginFn,
  } = useMutation({
    mutationFn: login,
    onSuccess: async (data) => {
      if (data.status === "2fa_required") {
        return navigate("/auth/verify-otp");
      }

      setUser(data.user);
      queryClient.setQueryData(["user"], data.user);

      // Prefetch resume data after successful login
      try {
        await queryClient.fetchQuery({
          queryKey: RESUMES_KEY,
          queryFn: fetchResumes,
        });
      } catch (error) {
        console.error("Error prefetching resumes on login:", error);
        // Don't fail the login if resume fetch fails
      }
    },
  });

  return { login: loginFn, loading, error };
};
